export default __webpack_public_path__ + "static/media/fullScreen.ebf8bf15.svg";